import { storageKeys } from '../browser-storage/storage-keys';
import session from '../session';

let _user = { profileDetails: { invoiceDetails: {} } } as User;

export const setUserData = (user: User): void => {
    _user = user;
};

export const getUserData = (): User => _user;

export const storedUserData = () => ({
    isAuthor: String(Number(JSON.parse(window.storage.getItem(storageKeys.user.isSeller) || 0))),

    loginState: Boolean(session.isLoggedIn()),
    // id: window.storage.getItem(storageKeys.user.userId),
    signUpDate: window.storage.getItem(storageKeys.user.userSD),

    signUpSource: window.storage.getItem(storageKeys.user.creationSource),
    // "searchType": storage.getItem(storageKeys.user.creationSource.searchType),
    subjects: ''
});
